// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_buttonone_btn-primary__2IEBC","container":"_buttonone_container__2g7IO","button":"_buttonone_button__17jIj"};